// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import {useLocation} from 'react-router';
import styles from '../toolip/faq_section.module.less';
import {Faq_section} from '../toolip/faq_section';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import hola_opt from 'hola_opt';
import {Editor} from '../../../../shared/editor/editor';
import cn from 'classnames';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';

const title_map = {
    'ad-verification':
        <Fragment>FAQs about Proxies<br/>and Ad Verification</Fragment>,
    'fraud-detection':
        <Fragment>FAQs about Proxies<br/>and Detecting Fraud</Fragment>,
    'lead-generation':
        <Fragment>FAQs about Proxies<br/>and Lead Generation</Fragment>,
    'price-monitoring':
        <Fragment>FAQs about Proxies<br/>and Price Monitoring</Fragment>,
    'product-development':
        <Fragment>FAQs about Proxies<br/>and Product Development
        </Fragment>,
    'sentiment-analysis':
        <Fragment>FAQs about Proxies<br/>and Sentiment Analysis
        </Fragment>,
    'seo':
        <Fragment>FAQs about Proxies and SEO</Fragment>,
    'sneakers':
        <Fragment>FAQs about Proxies<br/>and Events & Sneakers</Fragment>,
    'social-media':
        <Fragment>FAQs about Proxies<br/>and Social Media Management
        </Fragment>,
    'travel':
        <Fragment>
            FAQs about Proxies<br/>and Global Travel Data Comparisons
        </Fragment>,
    'web-scraping':
        <Fragment>So, Web Scraping, Data Collection<br/>and Proxies</Fragment>,
    'proxies-for-ai':
        <Fragment>So, AI Training and Proxies</Fragment>,
    'proxies-for-gaming':
        <Fragment>FAQs about Proxies and Gaming</Fragment>,
    'academic':
        <Fragment>FAQs about Proxies<br/>and Academic Research</Fragment>,
    'software-testing':
        <Fragment>FAQs about Proxies and Software Testing</Fragment>,
    'ecommerce':
        <Fragment>FAQs about Proxies and E-commerce</Fragment>,
    'real-estate':
        <Fragment>FAQs about Proxies and Real Estate</Fragment>,
    'job-scraping':
        <Fragment>FAQs about Proxies and Job Scraping
        </Fragment>,
    'crypto':
        <Fragment>FAQs about Proxies and Crypto</Fragment>,
    'streaming':
        <Fragment>FAQs about Proxies for Streaming </Fragment>
};

const case_to_collection_map = {
    'web-scraping': 'Web Scraping &amp; Data Collection',
    'ad-verification': 'Ad Verification',
    'price-monitoring': 'Price Monitoring',
    'social-media': 'Social Media Management',
    'travel': 'Global Travel Data Comparisons',
    'fraud-detection': 'Anti-Fraud',
    'seo': 'SEO Monitoring and Management',
    'sentiment-analysis': 'Sentiment Analysis',
    'product-development': 'Product Development',
    'lead-generation': 'Lead Generation',
    'sneakers': 'Events &amp; Sneakers access',
    'proxies-for-ai': 'AI Training',
    'proxies-for-gaming': 'Proxies for Gaming',
    'academic': 'Academic Research',
    'software-testing': 'Software Testing',
    'ecommerce': 'E-commerce Intelligence',
    'real-estate': 'Real Estate Intelligence',
    'job-scraping': 'Job Scraping &amp; Recruitment',
    'crypto': 'Crypto &amp; NFT Trading',
    'streaming': 'Streaming and Content Unblocking'
};

const get_faq_for_use_case = current_case=>{
    const collection = hola_opt.intercom_articles?.['USE CASES'] || {};
    const collection_key = case_to_collection_map[current_case];
    return collection[collection_key] || [];
};

export const obj_to_arr = fd_obj=>{
    return Object.keys(fd_obj).map(key=>({
        quest: fd_obj[key].title,
        ans: fd_obj[key].body
    }));
};

interface i_use_case_faq_props {
    current_case: string;
    title?: string | JSX.Element;
    title_tag?: string;
}

export const Use_case_faq = (props: i_use_case_faq_props)=>{
    const {current_case, title, title_tag} = props;
    const {pathname} = useLocation();
    const {theme} = useContext(Settings_context);
    const get_data_id =()=>`schema-faqs-${pathname}`;
    const {data} = use_data_provider(get_data_id);
    const final_title = title ?? title_map[current_case] ?? 'Some FAQs';
    const faq_data_obj = get_faq_for_use_case(current_case);
    const faq_data = obj_to_arr(faq_data_obj);
    const is_editor_change =
        JSON.stringify(data?.result?.data) !== JSON.stringify(faq_data);

    return <div className={cn(styles.faq, styles.faq_block)}>
      <Dynamic_heading tag={title_tag || 'h2'}
        className={cn(styles.title_heading)}>{final_title}</Dynamic_heading>
      <p className={theme.u1}>Let's get into it</p>
      <Faq_section custom_questions={is_editor_change
        ? faq_data : data?.result?.data} no_title color='transparent'/>
    </div>;
};

interface i_use_case_faq_editor_value {
    title?: string;
    current_case?: string;
}

interface i_use_case_faq_editor_props {
    value?: i_use_case_faq_editor_value;
    on_change: (value: i_use_case_faq_editor_value)=>void;
}

export const Use_case_faq_editor = (props: i_use_case_faq_editor_props)=>{
    const {value = {}, on_change} = props;
    type editor_key = keyof i_use_case_faq_editor_value;
    type editor_type = 'text' | 'textarea';
    const case_options = 'web-scraping, ad-verification, price-monitoring, '
        +'social-media, travel, fraud-detection, seo, sentiment-analysis, '
        +'product-development, lead-generation, sneakers, proxies-for-ai, '
        +'proxies-for-gaming, academic, software-testing, ecommerce, '
        +'real-estate, job-scraping, crypto, streaming';
    const editors = [
        ['title', 'FAQ Title (use \\n for line breaks)', 'textarea'],
        ['title_tag', 'FAQ Title Tag', 'select_tag_selector'],
        ['current_case', `Use Case (${case_options})`, 'text']
    ].map(([key, label, type])=>({
        key: key as editor_key,
        label,
        type: type as editor_type
    }));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Use Case FAQ Editor"
    />;
};
